import Phaser from 'phaser';
import { SCENE_KEYS } from '../config';

export class BriefingScene extends Phaser.Scene {
  constructor() { super({ key: SCENE_KEYS.BRIEFING }); }

  create(data: { title?: string; text?: string; image?: string }): void {
    const { width, height } = this.cameras.main;
    this.cameras.main.setBackgroundColor('#0a0a1a');

    const title = data.title || 'SIGUIENTE NIVEL';
    const text = data.text || 'Prepárate para la aventura.';

    // Imagen placeholder si se define
    if (data.image && this.textures.exists(data.image)) {
      const img = this.add.image(width / 2, height * 0.3, data.image);
      img.setDisplaySize(Math.min(width * 0.6, 400), Math.min(height * 0.35, 200));
      img.setOrigin(0.5);
    } else {
      // Placeholder visual: silhouette de La Habana
      this.drawHavanaSilhouette(width, height);
    }

    // Título
    this.add.text(width / 2, height * 0.12, title, {
      fontSize: '42px', fontFamily: 'Arial Black, Impact, sans-serif',
      color: '#ffcc00', stroke: '#000', strokeThickness: 4,
    }).setOrigin(0.5);

    // Texto con typewriter
    const bodyText = this.add.text(width / 2, height * 0.55, '', {
      fontSize: '18px', fontFamily: 'Arial, sans-serif',
      color: '#ffffff', lineSpacing: 8,
      wordWrap: { width: width * 0.7 }, align: 'center',
    }).setOrigin(0.5);

    let idx = 0;
    const typeTimer = this.time.addEvent({
      delay: 35,
      repeat: text.length - 1,
      callback: () => {
        idx++;
        bodyText.setText(text.substring(0, idx));
      },
    });

    // Skip
    const skipBtn = this.add.text(width - 20, height - 20, 'SKIP ▶▶', {
      fontSize: '16px', fontFamily: 'monospace', color: '#888',
      backgroundColor: '#00000066', padding: { x: 8, y: 4 },
    }).setOrigin(1, 1).setDepth(10).setInteractive({ useHandCursor: true });

    const goToGame = () => {
      this.scene.start(SCENE_KEYS.GAME);
    };

    skipBtn.on('pointerdown', () => { typeTimer.remove(); bodyText.setText(text); goToGame(); });
    this.input.keyboard?.on('keydown-ENTER', () => { typeTimer.remove(); goToGame(); });
    this.input.keyboard?.on('keydown-SPACE', () => { typeTimer.remove(); goToGame(); });
    this.input.on('pointerdown', (ptr: Phaser.Input.Pointer) => {
      if (!skipBtn.getBounds().contains(ptr.x, ptr.y)) {
        // Tap fuera de skip: si typewriter terminó, ir al juego
        if (idx >= text.length) goToGame();
      }
    });
  }

  private drawHavanaSilhouette(w: number, h: number): void {
    const g = this.add.graphics();
    const baseY = h * 0.38;
    // Edificios
    g.fillStyle(0x1a1a2e);
    g.fillRect(w * 0.1, baseY - 80, 40, 80);
    g.fillRect(w * 0.2, baseY - 120, 50, 120);
    g.fillRect(w * 0.35, baseY - 60, 35, 60);
    g.fillRect(w * 0.45, baseY - 140, 45, 140);
    g.fillRect(w * 0.55, baseY - 90, 55, 90);
    g.fillRect(w * 0.7, baseY - 110, 40, 110);
    g.fillRect(w * 0.8, baseY - 70, 50, 70);
    // Capitolio dome
    g.fillStyle(0x2a2a4e);
    g.fillEllipse(w * 0.5, baseY - 150, 60, 30);
    g.fillRect(w * 0.5 - 2, baseY - 170, 4, 20);
    // Mar
    g.fillStyle(0x0a2a4a, 0.5);
    g.fillRect(0, baseY, w, h - baseY);
  }
}
